import React, { useState, useContext, useEffect, useRef } from 'react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import "./i18n";
import SharedStateContext from './context/sharedstate';
import { AuthContext } from "./context/AuthContext";



const Navbaranonuser = ({isLoggedIn, onLogout }) => {
  const { auth } = useContext(AuthContext);

  // State to manage the navbar's visibility
  const [nav, setNav] = useState(false);

  // Toggle function to handle the navbar's display
  const handleNav = () => {
    setNav(!nav);
  };

  const { t, i18n } = useTranslation();
  const {interfaceLanguage, setInterfaceLanguage } = useContext(SharedStateContext);

  // Claude: bugfix reported directly — "About us, Add term, Search, Actions, Login, etc. do not
  // Claude: always appear exactly aligned... About us is a few pixels too high." Same fix as
  // Claude: navbar.js: the About button put all its padding on itself, but the Search/Login link
  // Claude: below had padding on both the <li> (p-2) AND the link (px-1 pt-1, top only) — a
  // Claude: taller, asymmetric box that shifted its text relative to the button. One shared class
  // Claude: for every top-level item's clickable element keeps them from drifting apart again.
  const NAV_ITEM_CLASS =
    "text-gray-800 bg-white p-2 hover:bg-gray-100 rounded-md cursor-pointer duration-300 hover:text-black text-sm font-medium inline-flex items-center";

  // Claude: "changing 'About us' to a dropdown that includes 'Contact us' and the user manual" —
  // requested directly. Same dropdown mechanism navbar.js (the logged-in nav) already uses for its
  // own "About us" dropdown and "Actions" button.
  const [aboutOpen, setAboutOpen] = useState(false);
  const toggleAbout = () => setAboutOpen(!aboutOpen);
  const aboutRef = useRef(null);

  // Claude: bugfix reported directly — "the Actions menu backdrop intercepts clicks, so underlying
  // Claude: links sometimes cannot be chosen." Same fix as navbar.js: an invisible, fixed inset-0
  // Claude: div swallowed the first click on anything else on the page while this dropdown was
  // Claude: open. A document-level "was this click outside the dropdown" listener closes it without
  // Claude: intercepting the click, so a click on another link both closes the dropdown and reaches
  // Claude: that link.
  useEffect(() => {
    function handleClickOutside(event) {
      if (aboutOpen && aboutRef.current && !aboutRef.current.contains(event.target)) {
        setAboutOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [aboutOpen]);

  const aboutItems = [
    { id: 5, text: <Link to="/about" className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md" onClick={() => setAboutOpen(false)}>{t("about")}</Link> },
    { id: 6, text: <Link to="/contact" className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md" onClick={() => setAboutOpen(false)}>{t("contact")}</Link> },
    { id: 7, text: <Link to="/user-manual" className="block px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100 rounded-md" onClick={() => setAboutOpen(false)}>{t("user_manual")}</Link> },
  ];

  // Array containing navigation items
  const navItems = [
    {
      id: 3,
      text:
        localStorage.getItem("bladsy") === "LandingPage" ?
      (
        <Link
          to="/advanced"
          className={NAV_ITEM_CLASS}
        >
          {" "}
          {t("advanced")}{" "}
        </Link>
      ) : (
        <Link
          to="/"
          className={NAV_ITEM_CLASS}
        >
          {" "}
          {t("search")}{" "}
        </Link>
      ),
    },
    { id: 4, text: auth.userName == null ? (<Link to="/login" className={NAV_ITEM_CLASS}> {t("login")} </Link>) : (<Link to="/logout" className={NAV_ITEM_CLASS}> {t("logout")} </Link>) },
  ];
    console.log(auth.userName);


  return (
    <div className='bg-white shadow-lg flex justify-between items-center h-12 max-w-5xl mx-auto px-3'>
      {/* Logo */}

      {/* Desktop Navigation */}
      <ul className='hidden lg:flex items-center'>
        {/* Claude: "changing 'About us' to a dropdown that includes 'Contact us' and the user
            manual" — requested directly. */}
        <li className="relative m-2" ref={aboutRef}>
          <button
            onClick={toggleAbout}
            className={NAV_ITEM_CLASS}
          >
            {t("about")}
            <span className="ml-1">▾</span>
          </button>
          {aboutOpen && (
            <div
              data-testid="about-drawer"
              className="absolute left-0 top-full mt-1 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-50 py-1"
            >
              <ul>
                {aboutItems.map(item => (
                  <li key={item.id}>{item.text}</li>
                ))}
              </ul>
            </div>
          )}
        </li>
        {navItems.map(item => (
          <li
            key={item.id}
            className='m-2'
          >
            {item.text}
          </li>
        ))}
      </ul>

      {/* Mobile Navigation Icon */}
      <div onClick={handleNav} className='block lg:hidden'>
        {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
      </div>

      {/* Mobile Navigation Menu */}
      <ul
        className={
          nav
            ? 'fixed lg:hidden left-0 top-0 w-[40%]  mt-12 bg-white ease-in-out duration-200 lg:space-y-0  space-y-2 overflow-auto'
            : 'ease-in-out w-[60%] duration-2 fixed top-0 bottom-12 left-[-100%]'
        }
      >
        {/* Mobile Logo */}

        {/* Mobile Navigation Items */}
        {[...aboutItems, ...navItems].map(item => (
          <li
            key={item.id}
            className='bg-gray-100 text-gray-800 p-2 rounded-md hover:bg-white-200 shadow-lg duration-300 hover:text-black cursor-pointer border-gray-600'
          >
            {item.text}
          </li>
        ))}
      </ul>

{auth.userName}

      <select
              value={interfaceLanguage}
              onChange={(e) => {setInterfaceLanguage(e.target.value);
                i18n.changeLanguage(e.target.value);
                localStorage.setItem("taal",e.target.value);
              }}
              className="border p-2 rounded-lg mr-4"
            >
              <option value="en">English</option>
              <option value="af">Afrikaans</option>
              <option value="zu">isiZulu</option>
              <option value="st">Sesotho</option> 
              <option value="nso">Sepedi</option>    
              <option value="tn">Setswana</option>  
              <option value="ts">Xitsonga</option>  
              <option value="ss">siSwati</option>   
              <option value="nr">isiNdebele</option>
              <option value="xh">isiXhosa</option>  
              <option value="ve">Tshivenḓa</option> 
              <option value="pt">Portuguese</option>
              <option value="fr">French</option>
              </select>
    </div>
  );
};

export default Navbaranonuser;
